import * as React from 'react';

import { ConfirmationDialog } from './components/ConfirmationDialog';
import { useDialogsProvider } from './useDialogsProvider';

export interface DialogsProviderProps {
  children: React.ReactNode;
}

const contextInitialValue = (
  title: string,
  handleClose: (confirmed: boolean) => void,
) => {};
export let Context = React.createContext(contextInitialValue);

export const DialogsProvider: React.FC<DialogsProviderProps> = ({
  children,
}) => {
  const { setConfirmationDialogSettingsRef, confirm } = useDialogsProvider();

  return (
    <Context.Provider value={confirm}>
      {children}
      <ConfirmationDialog
        setConfirmationDialogSettingsRef={setConfirmationDialogSettingsRef}
      />
    </Context.Provider>
  );
};
